import {packId} from 'common/diplomatIdUtil';
import {each, get, isEmpty, map} from 'lodash';
import {State} from 'redux/reducer';
import {createSelector} from 'reselect';
import {ISftpUser} from 'types/diplomat/sftp/SftpUser';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {IPartner} from 'types/partners';
import {commonPageKey} from './types';

const getDirtyValuesGetter = (state: State) => state[commonPageKey].dirtyValuesGetter;

const isPendingChanges = createSelector(
   getDirtyValuesGetter,
   (valuesGetters) => !isEmpty(valuesGetters)
);

// TODO add transactions with react-hook-form
const getPendingPartnersTransactions = createSelector(getDirtyValuesGetter, (getters) => {
   const partners = [] as IPartner[];
   const sftpUsers = [] as ISftpUser[];
   const transactions = [] as ITransaction[];

   const forms2 = map(getters, (g) => g.getValues());

   each(forms2, (f: IDiplomatObject) => {
      switch (f?.objectType) {
         case DiplomatObjectType.enum.INTERNAL_PARTNER:
         case DiplomatObjectType.enum.EXTERNAL_PARTNER:
            partners.push(f as IPartner);
            break;

         case DiplomatObjectType.enum.INBOUND_TRANSACTION:
         case DiplomatObjectType.enum.OUTBOUND_TRANSACTION:
         case DiplomatObjectType.enum.SYNCHRONIZATION:
            transactions.push(f as ITransaction);
            break;
         case DiplomatObjectType.enum.SFTP_USER:
            sftpUsers.push(f as ISftpUser);
      }
   });

   return {transactions, partners, sftpUsers};
});

const isDirty = (packedId: string) => (state: State) => {
   // check dirty values
   return !isEmpty(state.commonPage.dirtyValuesGetter[packedId]);
};

const getValues = (packedId: string) => (state: State) => {
   // check dirty values
   return state.commonPage.dirtyValuesGetter[packedId]?.getValues();
};

const getData = (state: State) => state.commonPage.data;
const getPackedId = createSelector(getData, (data: IDiplomatObject) =>
   packId(data.objectType, data.id)
);

const isSynchronization = (state: State) =>
   state[commonPageKey].data.objectType === DiplomatObjectType.enum.SYNCHRONIZATION;

export default {
   getData,
   getPackedId,
   getFromCache: (state: State, id: string) => get(state, ['commonPage', 'cache', id]),
   isFetching: (state: State) => state.commonPage.isFetching,
   proxies: (state: State) => state[commonPageKey].proxies,

   isDirty,
   isPendingChanges,
   getPendingPartnersTransactions,
   getDirtyValuesGetter: (packedId: string) => (state: State) =>
      state[commonPageKey].dirtyValuesGetter[packedId],
   getValues,
   isSynchronization,
};
